export default {
  'custom-mc': 'Multiple Choice',
  'multi-mc': 'Multi-Select',
  html: 'HTML Content',
};
